import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ScriptsService } from './script.service';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  constructor(
    private title: Title,
    private meta: Meta,
    private scriptsService: ScriptsService
  ) {}

  updateGameMeta(data: {
    title: string;
    description: string;
    url: string;
    imageUrl?: string;
    keywords?: string;
  }, addBrand: boolean = true): void {
    this.title.setTitle(`${data.title}${addBrand ? ' | Xedoom AI Quiz' : ''}`);
    this.meta.updateTag({ name: 'description', content: data.description });

    if (data.keywords) {
      this.meta.updateTag({ name: 'keywords', content: data.keywords });
    }

    // OpenGraph tags
    this.meta.updateTag({ property: 'og:title', content: data.title });
    this.meta.updateTag({ property: 'og:description', content: data.description });
    this.meta.updateTag({ property: 'og:url', content: data.url });
    if (data.imageUrl) {
      this.meta.updateTag({ property: 'og:image', content: data.imageUrl });
    }

    // Twitter tags
    this.meta.updateTag({ name: 'twitter:title', content: data.title });
    this.meta.updateTag({ name: 'twitter:description', content: data.description });
    if (data.imageUrl) {
      this.meta.updateTag({ name: 'twitter:image', content: data.imageUrl });
    }

    this.scriptsService.createCanonicalLink(data.url);
  }

  updateStructuredData(data: any): void {
    this.scriptsService.setStructuredDataScript(data);
  }

  cleanUp(): void {
    this.scriptsService.removeStructuredDataScript();
    this.scriptsService.removeCanonicalLink();
  }
}
